import axios from 'axios';

export const getLinkDistributions = params => axios.get('/user_invitation/codes/', { params: { ...params } });
export const createLinkDistribution = data => axios.post('/user_invitation/codes/', data);
export const updateLinkDistribution = ({ id, ...data }) => axios.patch(`/user_invitation/codes/${id}/`, data);
export const deleteLinkDistribution = id => axios.delete(`/user_invitation/codes/${id}/`);
export const getTags = () => axios.get('/common/tags/');
export const getShareToken = () => axios.get('/user_invitation/share-token/');
